<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-07 14:35:12
 -->
<template>
  <ul class="part12">
    <div class="title">同时提交歌谱 Scores</div>
    <ul class="lis">
      <li>
        <el-checkbox
          v-model="part12.activitySongChampion"
          :disabled="stateCode==6||stateCode==0?false:true"
        >每个曲目 7 份歌谱（冠军赛和资格鉴定）</el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part12.activitySongChampion"
          :disabled="stateCode==6||stateCode==0?false:true"
        >7 scores of each composition (The Champions Competition)</el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part12.activitySongOpen"
          :disabled="stateCode==6||stateCode==0?false:true"
        >每个曲目 5 份歌谱（公开赛）</el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part12.activitySongOpen"
          :disabled="stateCode==6||stateCode==0?false:true"
        >5 scores of each composition (The Open Competition)</el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part12.activitySongComment"
          :disabled="stateCode==6||stateCode==0?false:true"
        >每个曲目 3 份歌谱（点评表演）</el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part12.activitySongComment"
          :disabled="stateCode==6||stateCode==0?false:true"
        >3 scores of each composition (Evaluation Performance)</el-checkbox>
      </li>
      <li>
        <el-checkbox v-model="part12.activitySongTutorial">1 份曲谱（个别指导）</el-checkbox>
      </li>
      <li>
        <el-checkbox
          v-model="part12.activitySongTutorial"
          :disabled="stateCode==6||stateCode==0?false:true"
        >1 score (Individual Coaching)</el-checkbox>
      </li>
      <div class="conbox">
        <div class="left">
          <p>信用卡支付报名费</p>
          <el-checkbox
            v-model="part12.activityVisacard"
            :disabled="stateCode==6||stateCode==0?false:true"
          >VISA 信用卡(VISACARD)</el-checkbox>
          <el-checkbox
            v-model="part12.activityMastercard"
            :disabled="stateCode==6||stateCode==0?false:true"
          >万事达信用卡（MASTERCARD）</el-checkbox>
        </div>
        <div class="right">
          <ul>
            <li>
              <el-input
                placeholder="请输入内容"
                v-model="part12.cardholderNameCh"
                :disabled="stateCode==6||stateCode==0?false:true"
              >
                <template slot="prepend">持卡人姓名：</template>
              </el-input>
            </li>
            <li>
              <el-input
                placeholder="请输入内容"
                v-model="part12.cardNumberCh"
                :disabled="stateCode==6||stateCode==0?false:true"
              >
                <template slot="prepend">卡号：</template>
              </el-input>
            </li>
            <li>
              <el-input
                placeholder="yyyy.MM.dd"
                v-model="part12.periodDateCh"
                :disabled="stateCode==6||stateCode==0?false:true"
              >
                <template slot="prepend">有效期：</template>
              </el-input>
            </li>
            <li>
              <el-input
                placeholder="请输入内容"
                v-model="part12.authCodeCh"
                :disabled="stateCode==6||stateCode==0?false:true"
              >
                <template slot="prepend">验证码：</template>
              </el-input>
            </li>
            <li>
              <el-input
                placeholder="请输入内容"
                v-model="part12.signatureCh"
                :disabled="stateCode==6||stateCode==0?false:true"
              >
                <template slot="prepend">签名：</template>
              </el-input>
            </li>
          </ul>
        </div>
      </div>
      <div class="conbox">
        <div class="left">
          <p>Payment of registration fee by credit card</p>
          <el-checkbox
            v-model="part12.activityVisacard"
            :disabled="stateCode==6||stateCode==0?false:true"
          >Visacard</el-checkbox>
          <el-checkbox
            v-model="part12.activityMastercard"
            :disabled="stateCode==6||stateCode==0?false:true"
          >Mastercard</el-checkbox>
        </div>
        <div class="right">
          <ul>
            <li>
              <el-input
                placeholder="请输入内容"
                v-model="part12.cardholderNameEn"
                :disabled="stateCode==6||stateCode==0?false:true"
              >
                <template slot="prepend">Name of Cardholder：</template>
              </el-input>
            </li>
            <li>
              <el-input
                placeholder="请输入内容"
                v-model="part12.cardNumberEn"
                :disabled="stateCode==6||stateCode==0?false:true"
              >
                <template slot="prepend">Card number：</template>
              </el-input>
            </li>
            <li>
              <el-input
                placeholder="yyyy.MM.dd"
                v-model="part12.periodDateEn"
                :disabled="stateCode==6||stateCode==0?false:true"
              >
                <template slot="prepend">Expiration Date：</template>
              </el-input>
            </li>
            <li>
              <el-input
                placeholder="请输入内容"
                v-model="part12.authCodeEn"
                :disabled="stateCode==6||stateCode==0?false:true"
              >
                <template slot="prepend">Verification code：</template>
              </el-input>
            </li>
            <li>
              <el-input
                placeholder="请输入内容"
                v-model="part12.signatureEn"
                :disabled="stateCode==6||stateCode==0?false:true"
              >
                <template slot="prepend">Signature：</template>
              </el-input>
            </li>
          </ul>
        </div>
      </div>
    </ul>
    <ul class="part12s">
      <li>
        <el-input
          placeholder="请输入内容"
          v-model="part12.activityFillCityCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">填表地点（城市，国家）：</template>
        </el-input>
        <el-input
          placeholder="yyyy.MM.dd"
          v-model="part12.activityFillDateCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">填表日期：</template>
        </el-input>
        <el-input
          placeholder="请输入内容"
          v-model="part12.activityLinkmanCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">合唱团联系人签名：</template>
        </el-input>
        <el-input
          placeholder="请输入内容"
          v-model="part12.activityDirectorCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">指挥/艺术总监签名：</template>
        </el-input>
      </li>
      <li class="lengbox">
        <div class="box">
          <div class="box1" style="margin-top: 19px">
            <label for>City,Country：</label>
            <input
              type="text"
              v-model="part12.activityFillCityEn"
              :disabled="stateCode==6||stateCode==0?false:true"
            />
          </div>
        </div>

        <div class="box">
          <div class="box1" style="margin-top: 19px">
            <label for>Date：</label>
            <input
              type="text"
              v-model="part12.activityFillDateEn"
              :disabled="stateCode==6||stateCode==0?false:true"
            />
          </div>
        </div>

        <div class="box">
          <div class="box1">
            <label for>Signature of the contact person：</label>
            <input
              type="text"
              v-model="part12.activityLinkmanEn"
              :disabled="stateCode==6||stateCode==0?false:true"
            />
          </div>
        </div>

        <div class="box">
          <div class="box1" style="margin-top: 6px">
            <label for>Signature of the artistic director/conductor：</label>
            <input
              type="text"
              v-model="part12.activityDirectorEn"
              :disabled="stateCode==6||stateCode==0?false:true"
            />
          </div>
        </div>
      </li>
    </ul>
  </ul>
</template>

<script>
export default {
  props: {
    Scoresh: {
      type: Object,
      default() {
        return {
          type: 0,
          data: null,
        };
      },
    },
    stateCode: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  components: {},
  computed: {},
  data() {
    return {
      checked: false,
      part12: {
        activitySongChampion: false, //每个曲目 7 份歌谱（冠军赛）
        activitySongOpen: false, //每个曲目 5 份歌谱（公开赛）
        activitySongComment: false, //每个曲目 3 份歌谱（点评表演）
        activitySongTutorial: false, //1 份曲谱（个别指导）
        activityVisacard: false, //是否VISA 信用卡
        activityMastercard: false, //是否万事达信用卡

        cardholderNameCh: "", //持卡人姓名
        cardholderNameEn: "",
        cardNumberCh: "", //卡号
        cardNumberEn: "",
        periodDateCh: "", //有效期
        periodDateEn: "",
        authCodeCh: "", //验证码
        authCodeEn: "",
        signatureCh: "", //签名
        signatureEn: "",
        activityFillCityCh: "", //填表地点（城市、国家）
        activityFillCityEn: "",
        activityFillDateCh: "", //填表日期
        activityFillDateEn: "",
        activityLinkmanCh: "", //联系人签名
        activityLinkmanEn: "",
        activityDirectorCh: "", //指挥/艺术总监签名
        activityDirectorEn: "",
      },
    };
  },

  created() {},
  mounted() {
    this.getdetails();
  },
  methods: {
    getdetails() {
      this.part12.activitySongChampion = this.Scoresh.activitySongChampion;
      this.part12.activitySongOpen = this.Scoresh.activitySongOpen;
      this.part12.activitySongComment = this.Scoresh.activitySongComment;
      this.part12.activitySongTutorial = this.Scoresh.activitySongTutorial;
      this.part12.activityVisacard = this.Scoresh.activityVisacard;
      this.part12.activityMastercard = this.Scoresh.activityMastercard;

      this.part12.cardholderNameCh = this.Scoresh.cardholderNameCh;
      this.part12.cardholderNameEn = this.Scoresh.cardholderNameEn;
      this.part12.cardNumberCh = this.Scoresh.cardNumberCh;
      this.part12.cardNumberEn = this.Scoresh.cardNumberEn;
      this.part12.periodDateCh = this.Scoresh.periodDateCh;
      this.part12.periodDateEn = this.Scoresh.periodDateEn;
      this.part12.authCodeCh = this.Scoresh.authCodeCh;
      this.part12.authCodeEn = this.Scoresh.authCodeEn;
      this.part12.signatureCh = this.Scoresh.signatureCh;
      this.part12.signatureEn = this.Scoresh.signatureEn;
      this.part12.activityFillCityCh = this.Scoresh.activityFillCityCh;
      this.part12.activityFillCityEn = this.Scoresh.activityFillCityEn;
      this.part12.activityFillDateCh = this.Scoresh.activityFillDateCh;
      this.part12.activityFillDateEn = this.Scoresh.activityFillDateEn;
      this.part12.activityLinkmanCh = this.Scoresh.activityLinkmanCh;
      this.part12.activityLinkmanEn = this.Scoresh.activityLinkmanEn;
      this.part12.activityDirectorCh = this.Scoresh.activityDirectorCh;
      this.part12.activityDirectorEn = this.Scoresh.activityDirectorEn;
    },
  },
};
</script>

<style scoped="" lang="scss">
.part12 {
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3c4353;
    margin: 48px 100px;
  }
  .conbox {
    margin: auto;
    margin-left: 100px;
    margin-right: 100px;
    display: flex;
    margin-top: 20px;
    .left {
      width: 40%;
      border: 1px solid gainsboro;
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      p {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(36, 85, 139, 1);
        line-height: 34px;
      }
      .el-radio {
        width: 100%;
        margin-top: 21px;
      }
      .el-radio:last-of-type {
        margin-bottom: 20px;
      }
      .el-checkbox {
        margin-top: 15px;
        display: block;
        /deep/.el-checkbox__label {
          color: #24558b;
        }
      }
    }
    .right {
      width: 60%;
      border: 1px solid gainsboro;
      border-left: 0;
      li {
        display: flex;
        padding-left: 0px;
        padding-right: 0px;
        margin-top: 0px;
        border: 0px;
        margin-left: 0px;
        margin-right: 0px;
        .el-input {
          /deep/ .el-input-group__prepend {
            border-right: 0;
            border-bottom: 0;
            border-left: 0;
            color: rgba(36, 85, 139, 1);
            background: white;
            padding-right: 0px;
          }
          /deep/.el-input__inner {
            border-left: 0;
            border-right: 0;
            padding: 0 15px 0 0;
            border-bottom: 0;
            &:focus {
              border-color: #dcdfe6;
              outline: 0;
            }
          }
        }

        .radiobox {
          width: 30%;
          border: 1px solid gainsboro;
          .el-radio {
            margin-left: 30px;
            margin-top: 14px;
          }
        }
        p {
          color: rgba(36, 85, 139, 1);
          line-height: 32px;
        }
        &:first-of-type {
          .el-input {
            /deep/ .el-input-group__prepend {
              border-top: 0;
            }
            /deep/.el-input__inner {
              border-top: 0;
            }
          }
        }
      }
    }
  }
  .lis {
    li {
      border: 1px solid gainsboro;
      margin-left: 100px;
      margin-right: 100px;
      padding-left: 10px;
      padding-right: 0px;
      .el-checkbox {
        line-height: 34px;
        /deep/.el-checkbox__label {
          color: rgba(36, 85, 139, 1);
          input {
            outline: none;
            border: 0;
            border-bottom: 1px solid gray;
          }
        }
      }
    }
  }
  .part12s {
    margin-top: 10px;
    .lengbox {
      margin-top: 10px;

      label {
        color: rgba(36, 85, 139, 1);
      }

      .box {
        border: 1px solid #dcdfe6;
        .box1 {
          padding: 25px 20px;
          padding-bottom: 20px;
          display: flex;
          // display: flex;
          input {
            outline: none;
            border: 0;
            border-bottom: 1px solid gray;
            display: inline-block;
            width: 50%;
          }
        }
        &:nth-of-type(1) {
          width: 29%;
        }
        &:nth-of-type(2) {
          width: 21%;
        }
        &:nth-of-type(3) {
          width: 25%;
        }
        &:nth-of-type(4) {
          width: 25%;
        }
      }
    }
    li {
      display: flex;
      padding-left: 100px;
      padding-right: 100px;

      .el-input {
        /deep/ .el-input-group__prepend {
          border-right: 0;
          color: rgba(36, 85, 139, 1);
          background: white;
          padding-right: 0px;
        }
        /deep/.el-input__inner {
          border-left: 0;
          padding: 0 15px 0 0;
          &:focus {
            border-color: #dcdfe6;
            outline: 0;
          }
        }
        &:nth-of-type(1) {
          width: 29%;
        }
        &:nth-of-type(2) {
          width: 21%;
        }
        &:nth-of-type(3) {
          width: 25%;
        }
        &:nth-of-type(4) {
          width: 25%;
        }
      }

      .radiobox {
        width: 30%;
        border: 1px solid gainsboro;
        .el-radio {
          margin-left: 30px;
          margin-top: 14px;
        }
      }
      p {
        color: rgba(36, 85, 139, 1);
        line-height: 32px;
      }
    }
  }
  li {
    margin-top: 20px;
  }
  li:nth-of-type(3) {
    margin-top: 30px;
  }

  li:nth-of-type(5) {
    margin-top: 30px;
  }
  li:nth-of-type(7) {
    margin-top: 30px;
  }
  li:nth-of-type(9) {
    margin-top: 30px;
  }
  li:nth-of-type(11) {
    margin-top: 30px;
  }
  li:nth-of-type(13) {
    margin-top: 30px;
  }
}
</style>
